//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../Gateway/Gateway.ImageCaptureBuilder.js";
import "../Tooling/Tooling.SelectReuseLibraryItemBuilder.js";
import "../AME/AME.SelectAMEPort.js";
import "../no/ugmath.js";
import "../no/Gateway.js";
import "../no/SelectObject.js";
import "../no/Tooling.js";
let d=[[[0,"AnchorPointLocation",1,0],[1,"CapturedImage",0,"Gateway.ImageCaptureBuilder",0],[1,"SelectedCustomSymbol",0,"Tooling.SelectReuseLibraryItemBuilder",0],[1,"SelectedPort",0,"AME.SelectAMEPort",0],[0,"SymbolAnnotationPoint",0,0],[0,"Type",1,0]],[[["customSymbolPath"],"InsertSymbol",{R_:{custom_symbol:"Annotations.CustomSymbol"}},1,0],[["portToBeMapped"],"CreateConnectionPoint",{R_:{portID:''}},1,0],[["portID"],"GetConnectionPointLocation",{R_:{portLocation:''}},1,0],[["portID","portLocation"],"SetConnectionPointLocation",{},2,0],[["portID"],"GetConnectionDirection",{R_:{connectionDirection:''}},1,0],[["portID","connectionDirection"],"SetConnectionDirection",{},2,0],[["portToBeUnmapped","portID"],"DeleteConnectionPoint",{},2,0],[["portID","connPoint"],"CreateDefaultPortAnnotation",{},2,0]],[]];
SPLM.AME.SymbolAuthoringBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.SymbolAuthoringBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.AME.SymbolAuthoringBuilder.Types = Object.freeze({
    "StandardSymbol" : "StandardSymbol", "CableDefinitionLine" : "CableDefinitionLine"});

export default SPLM;